import React, { useMemo } from 'react';
import { CrmSelect } from '../ui';
import { useSettings } from '../../context/SettingsContext';

export const COMMUNICATION_SCOPE_TYPES = [
  { value: 'GLOBAL', label: 'Global' },
  { value: 'LEGAL_ENTITY', label: 'Legal Entity' },
  { value: 'BRAND', label: 'Brand' },
  { value: 'BUSINESS_UNIT', label: 'Business Unit' },
  { value: 'SALES_CHANNEL', label: 'Sales Channel' },
  { value: 'STOREFRONT', label: 'Storefront' },
];

const CATALOG_KEYS = {
  LEGAL_ENTITY: 'legal_entities',
  BRAND: 'brands',
  BUSINESS_UNIT: 'business_units',
  SALES_CHANNEL: 'sales_channels',
  STOREFRONT: 'storefronts',
};

const labelForRow = (row = {}) => row.name || row.display_name || row.legal_name || row.code || `#${row.id}`;

export const getScopeLabel = (scopeType, scopeId, catalog = {}) => {
  const normalizedType = String(scopeType || 'GLOBAL').toUpperCase();
  if (normalizedType === 'GLOBAL') return 'Global';
  const key = CATALOG_KEYS[normalizedType];
  const row = (catalog?.[key] || []).find((item) => Number(item.id) === Number(scopeId));
  const typeLabel = COMMUNICATION_SCOPE_TYPES.find((item) => item.value === normalizedType)?.label || normalizedType;
  return row ? `${typeLabel}: ${labelForRow(row)}` : `${typeLabel}: #${scopeId || '—'}`;
};

export default function ScopedSettingsFields({
  scopeType = 'GLOBAL',
  scopeId = '',
  onScopeTypeChange,
  onScopeIdChange,
  disabled = false,
  className = '',
}) {
  const { commercialCatalog } = useSettings();
  const options = useMemo(() => {
    const key = CATALOG_KEYS[String(scopeType || '').toUpperCase()];
    return key ? (commercialCatalog?.[key] || []) : [];
  }, [commercialCatalog, scopeType]);

  return (
    <div className={`phase13-form-grid phase13-form-grid--scope ${className}`.trim()}>
      <CrmSelect
        label="Scope"
        value={scopeType || 'GLOBAL'}
        disabled={disabled}
        onChange={(event) => {
          const nextType = event.target.value;
          onScopeTypeChange?.(nextType);
          if (nextType === 'GLOBAL') onScopeIdChange?.('');
        }}
      >
        {COMMUNICATION_SCOPE_TYPES.map((item) => (
          <option key={item.value} value={item.value}>{item.label}</option>
        ))}
      </CrmSelect>

      {scopeType !== 'GLOBAL' ? (
        <CrmSelect
          label={COMMUNICATION_SCOPE_TYPES.find((item) => item.value === scopeType)?.label || 'Scope record'}
          value={scopeId || ''}
          required
          disabled={disabled}
          onChange={(event) => onScopeIdChange?.(event.target.value)}
        >
          <option value="">Select…</option>
          {options.map((row) => (
            <option key={row.id} value={row.id}>{labelForRow(row)}</option>
          ))}
        </CrmSelect>
      ) : null}
    </div>
  );
}
